import React, { useEffect, useState } from 'react';
import { Table, Typography, Spin, Alert, Card, Select, Space, Tag, Row, Col } from 'antd';
import { baseurl } from '../../components/lib/settings';
import { format } from 'date-fns';
import { LoadingOutlined, SearchOutlined, DollarOutlined, CalendarOutlined } from '@ant-design/icons';
import './VotingQuery.css';

const { Title, Text } = Typography;
const { Option } = Select;

function VotingQuery() {
    const [error, setError] = useState("");
    const [votingQueryData, setVotingQueryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [totalAmount, setTotalAmount] = useState(0);

    const fetchVotingData = async (year) => {
        setLoading(true);
        try {
            const response = await baseurl.post("v3/ngoma/administrator/musician/query_votings/amount/", { year });
            const data = response.data;

            const filteredData = data.filter(item => new Date(item.created_at).getFullYear() === year);
            const total = filteredData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);

            setVotingQueryData(filteredData);
            setTotalAmount(total);
            setLoading(false);
        } catch (error) {
            setError(error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVotingData(selectedYear);
        const intervalId = setInterval(() => {
            fetchVotingData(selectedYear);
        }, 60000); // 1 minuto para reduzir a carga
        
        return () => clearInterval(intervalId);
    }, [selectedYear]);

    const formatEndDate = (formatDate) => {
        if (!formatDate) return "";
        return format(new Date(formatDate), "dd/MM/yyyy HH:mm");
    };

    const getStatusColor = (status) => {
        const lowerStatus = (status || "").toLowerCase();
        if (lowerStatus.includes('sucess') || lowerStatus.includes('pago')) return 'success';
        if (lowerStatus.includes('pendente') || lowerStatus.includes('process')) return 'warning';
        if (lowerStatus.includes('falha') || lowerStatus.includes('erro')) return 'error';
        return 'default';
    };

    // const columns = [
    //     {
    //         title: 'Descrição',
    //         dataIndex: 'description',
    //         key: 'description',
    //         width: '120',
    //         render: (text) => <Text strong style={{ color: "#374151" }}>{text}</Text>
    //     },
    //     {
    //         title: 'Contacto',
    //         dataIndex: 'msisdn',
    //         key: 'msisdn',
    //         width: '120',
    //         render: (text) => <Text style={{ color: "#4b5563" }}>{text}</Text>
    //     },
    //     {
    //         title: 'Montante',
    //         dataIndex: 'amount',
    //         key: 'amount',
    //         width: '120',
    //         align: 'right',
    //         render: (amount) => (
    //             <Text strong style={{ color: "#166534" }}>
    //                 {parseFloat(amount).toLocaleString('pt-BR', { style: 'currency', currency: 'MZN' })}
    //             </Text>
    //         )
    //     },
    //     {
    //         title: 'Status',
    //         dataIndex: 'status',
    //         key: 'status',
    //         width: '120',
    //         render: (status) => (
    //             <Tag color={getStatusColor(status)} style={{ borderRadius: "12px", border: "none", padding: "2px 10px", textTransform: "capitalize" }}>
    //                 {status || "N/A"}
    //             </Tag>
    //         )
    //     },
    //     {
    //         title: 'Data da Transação',
    //         dataIndex: 'created_at',
    //         key: 'created_at',
    //         width: '120',
    //         render: (created_at) => (
    //             <Text type="secondary" style={{ fontSize: "13px" }}>
    //                 {formatEndDate(created_at)}
    //             </Text>
    //         )
    //     },
    // ];

    const columns = [
    {
        title: 'Descrição',
        dataIndex: 'description',
        key: 'description',
        width: 600,
        render: (text) => (
            <Text strong style={{ color: "#374151" }}>
                {text}
            </Text>
        ),
    },
    {
        title: 'Contacto',
        dataIndex: 'msisdn',
        key: 'msisdn',
        width: 130,
        render: (text) => (
            <Text style={{ color: "#4b5563" }}>
                {text}
            </Text>
        ),
    },
    {
        title: 'Montante',
        dataIndex: 'amount',
        key: 'amount',
        width: 120,
        align: 'right',
        render: (amount) => (
            <Text strong style={{ color: "#166534" }}>
                {parseFloat(amount).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'MZN',
                })}
            </Text>
        ),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 110,
        render: (status) => (
            <Tag
                color={getStatusColor(status)}
                style={{
                    borderRadius: "12px",
                    border: "none",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                }}
            >
                {status || "N/A"}
            </Tag>
        ),
    },
    {
        title: 'Data da Transação',
        dataIndex: 'created_at',
        key: 'created_at',
        width: 160,
        render: (created_at) => (
            <Text type="secondary" style={{ fontSize: "13px" }}>
                {formatEndDate(created_at)}
            </Text>
        ),
    },
];

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= 2023; i--) {
            years.push(<Option key={i} value={i}>{i}</Option>);
        }
        return years;
    };

    return (
        <div style={{ padding: "22px", background: "#f3f4f6", minHeight: "100vh" }}>
            <div style={{ marginBottom: "32px", display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "16px" }}>
                <Space direction="vertical" size={4}>
                    <Title level={4} style={{ margin: 0, color: "#111827", fontWeight: 700 }}>
                        <SearchOutlined style={{ color: "#1890ff", marginRight: "12px" }} />
                        Relatório de Consultas
                    </Title>
                    <Text type="secondary" style={{ fontSize: "15px" }}>
                        Verifique e audite o detalhe de cada transação efetuada.
                    </Text>
                </Space>
            </div>

            {error && <Alert message="Erro de Comunicação" description={error} type="error" showIcon style={{ marginBottom: "24px", borderRadius: "12px" }} />}

            <Row gutter={[24, 24]} style={{ marginBottom: "20px" }}>
                <Col xs={24} md={8}>
                    {/* <Card 
                        bordered={false} 
                        style={{ borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", height: "100%" }}
                        bodyStyle={{ padding: "24px", display: "flex", flexDirection: "column", }}
                    > */}
                        <Text type="secondary" style={{ display: "block", marginBottom: "8px", fontWeight: 600, textTransform: "uppercase", fontSize: "12px" }}>
                            <CalendarOutlined style={{ marginRight: "6px" }} /> Período de Análise
                        </Text>
                        <Select
                            value={selectedYear}
                            size="large"
                            style={{ width: "100%" }}
                            onChange={handleYearChange}
                        >
                            {generateYearOptions()}
                        </Select>
                    {/* </Card> */}
                </Col>

                <Col xs={24} md={16}>
                    {/* <Card 
                        bordered={false} 
                        style={{ borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)", height: "100%" }}
                        bodyStyle={{ padding: "24px", display: "flex" }}
                    > */}
                        <div>
                            <Text style={{ color: "#166534", fontSize: "11px", fontWeight: 600, textTransform: "uppercase" }}>Total Arrecadado em {selectedYear}</Text>
                            <Title level={3} style={{ margin: 0, marginTop: "8px", color: "#15803d", fontWeight:600 }}>
                                {totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'MZN' })}
                            </Title>
                        </div>
                        {/* <div style={{ background: "#fff", padding: "16px", borderRadius: "50%", boxShadow: "0 4px 12px rgba(21, 128, 61, 0.15)" }}>
                            <DollarOutlined style={{ fontSize: "32px", color: "#16a34a" }} />
                        </div> */}
                    {/* </Card> */}
                </Col>
            </Row>

            <Card 
                bordered={false} 
                style={{ borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}
                bodyStyle={{ padding: "0" }}
            >
                {loading ? (
                    <div style={{ padding: "90px 0",  }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 40, color: "#1890ff" }} spin />} tip="A sincronizar dados..." size="large" />
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={votingQueryData}
                        rowKey="id"
                        onChange={handleTableChange}
                        pagination={{ pageSize: 20,  }}
                        scroll={{ x: 800 }}
                        style={{ margin: 0 }}
                    />
                )}
            </Card>

            {/* <style>{`
                .ant-table-wrapper {
                    border-radius: 16px;
                    overflow: hidden;
                }
                .ant-table-thead > tr > th {
                    background-color: #f8fafc !important;
                    color: #4b5563 !important;
                    font-weight: 600 !important;
                    text-transform: uppercase;
                    font-size: 12px;
                    letter-spacing: 0.5px;
                    padding: 16px 24px !important;
                    border-bottom: 1px solid #e5e7eb !important;
                }
                .ant-table-tbody > tr > td {
                    padding: 16px 24px !important;
                    border-bottom: 1px solid #f3f4f6 !important;
                }
                .ant-table-tbody > tr:hover > td {
                    background-color: #f9fafb !important;
                }
                .ant-pagination {
                    margin-top: 24px !important;
                    margin-bottom: 24px !important;
                }
            `}</style> */}
        </div>
    );
}

export default VotingQuery;